<template lang="pug">
  Modal(v-if="modal.show", @close="modal.show=false" )
    span(slot="header") {{ modal.title }}
    template(slot="content")
      validation-observer(ref="observer" tag="form" @submit.prevent="save_sport")
        .row
          .form-col.large-24
            .field
              label {{t("app.registration.show.grade")}}
                validation-provider(rules="required" name="grade" v-slot="{ errors }" :class="{error: errors[0]}")
                  .select
                    span.selected
                      span.value(v-if="modal.object.grade") {{ modal.object.grade}}
                      span.value(v-else) {{ grade_select }}
                      span.caret
                    select(v-model="modal.object.grade" @change="onChangeGrade($event)")
                      option(value="", disabled) Select grade
                      option(:value="grade.value" v-for="grade in grades" :disabled="isGradeSelected(grade.value)") {{ grade.value }}
        .row
          .form-col.large-24
            .field
              label {{t('app.registration.transfer_request.sport')}}
                validation-provider(rules="required" name="sport" v-slot="{ errors }")
                  .select
                    span.selected
                      span.value {{t("app.buttons.select")}}
                      span.caret
                    select(@change="onChangeSport($event)")
                      option(value="", selected disabled) Select sport
                      option(:value="sport.genericSportName" v-for="sport in sports") {{ sport.genericSportName }}
                  ul.sports-list
                    li(v-for="(sport, idx) in sportsSelect" v-if="!modal.object.id")
                      span.clipped
                        span {{sport}}
                      span.icon-trash(@click="deleteItem(sport)")
                    li(v-for="(sport, idx) in modal.object.sports")
                      span.clipped
                        span {{sport}}
                      span.icon-trash(@click="deleteSavedItem(sport, modal.object.id)")     
        .row
          .form-col.large-24
            .buttons
              .left
                a(@click="closeModal()" class="button secondary") {{t('app.buttons.cancel')}}
              .right
                a(@click="validate" class="button") {{t('app.buttons.save')}}
</template>
<script>

import Modal from "../shared/_modal";

export default{
  components:{ Modal},
  props: {
    modal: {
      type: Object,
      default(){
        return {}
      },
    },
    type: { 
      type: String,
      default: ""
    },
    sportsPlayed: {
      type: Array,
      default(){
        return []
      },
    },
    savedSports: {
      type: Array,
      default(){
        return []
      },
    },
    sports: {
      type: Array,
      default(){
        return []
      },
    },
    errors: {
      type: Object,
      default(){
        return {}
      },
    },
    sendingSport: {
      type: Object,
      default(){
        return {}
      },
    },
    sportError: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      grades: [
        { value: '9th' },
        { value: '10th' },
        { value: '11th' },
        { value: '12th' },
      ],
      grade: "",
      grade_select: "Select",
      sportsSelect: [],
      deletedSports: {},
    }
  },
  methods:{
    isGradeSelected(grade) {
      const selectedGrades = Object.values(this.sendingSport.data).map(student => student.grade);
      return selectedGrades.includes(grade);
    },
    save_sport(){
      if(this.modal.object.id){
        this.update_sport()
      }else{
        const hash = { id: Math.floor(Math.random() * 1000000), grade: this.grade, sports: this.sportsSelect }
        this.$set(this.sportsPlayed, this.sportsPlayed.length, hash)
        const length = (Object.keys(this.sendingSport.data).length + this.sportsPlayed.length)
        this.$set(this.sendingSport.data, length + 1, hash)
        this.sportsSelect = []
        this.grade = ""
        this.grade_select = "Select"
      }
      this.$set(this.sportError, 'required', false)
      this.$set(this.modal, 'show', false)
    },
    update_sport(){
      Object.keys(this.deletedSports).forEach(gradeId => {
        const item = this.sportsPlayed.find(item => item.id === parseInt(gradeId))
        if (item) {
          this.deletedSports[gradeId].forEach(sportName => {
            if (item.sports.includes(sportName)) {
              item.sports.splice(item.sports.indexOf(sportName), 1)
            }
          })
        }
      })
      this.deletedSports = {}
      const selected_idx = this.sportsPlayed.indexOf(this.sportsPlayed.find(x => x.id === this.modal.object.id));
      if (selected_idx === -1) {
        const item = Object.values(this.savedSports).find(record => record.id === this.modal.object.id);
        item.sports = this.modal.object.sports
        return false
      }
      const array = []
      for (const value of this.sportsSelect) {
        array.push(value)
      }

      for (const value of this.sportsPlayed[selected_idx].sports) {
        array.push(value)
      }
      this.sportsSelect = []
      
      const grade = this.grade == "" ? this.modal.object.grade : this.grade
      this.$set(this.sportsPlayed[selected_idx], 'grade', grade)
      this.$set(this.sportsPlayed[selected_idx], 'sports', array)

    },
    onChangeGrade(event) {
      this.grade_select = event.target.value
      this.grade = event.target.value
    },
    onChangeSport(event) {
      const target_value = event.target.value
      this.sportsSelect.push(target_value)
      if(this.modal.object.id){
        this.modal.object.sports.push(target_value)
      }
    },
    deleteItem(value){
      const selected_idx = this.sportsSelect.findIndex(x => x === value)
      this.sportsSelect.splice(selected_idx, 1)
    },
    deleteSavedItem(name, modal_id) {
      this.modal.object.sports.splice(this.modal.object.sports.indexOf(name), 1)
      const item = this.sportsPlayed.find(x => x.id === modal_id)
      if (item) {
        if (!this.deletedSports[modal_id]) {
          this.deletedSports[modal_id] = [name];
        } else {
          this.deletedSports[modal_id].push(name);
        }
      }
    },
    validate(){
      this.$refs.observer.validate().then((valid) => {
        if (!valid) return;
        this.save_sport()
      });
    },
    closeModal(){
      this.grade_select = "Select"
      this.sportsSelect = []
      this.$set(this.modal, 'show', false)
    }
  }
}
</script>
<style scoped>
  li{
  display: inline-block;
  background-color: #fafafa;
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 7px 5px 7px 10px;
  .clipped{
    float: left
  }
}
.icon-trash{
  float: right;
  margin-top: 4px;
  width: 14px !important;
  height: 14px !important;
}
</style>
